<template>
  <div>
    <MediaImage
      v-bind="image"
      responsive-style="column_half"
      :crop-alignment="cropAlignment"
      fit="scale"
      class="pointer-events-none aspect-4/3 w-full overflow-hidden"
      image-class="h-full w-full object-cover"
    />
    <div class="mt-3 text-size-6 text-muted">{{ description }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphImageFragment } from '#graphql-operations'
import { resolveCantoCropAlignment } from '~/helpers/canto'

const props = defineProps<ParagraphImageFragment>()

const { options } = defineBlokkli({
  bundle: 'image',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    cropAlignment: {
      type: 'radios',
      label: 'Fokus',
      default: 'mc',
      options: {
        tl: { label: 'Oben links', description: 'Oben links' },
        tc: { label: 'Oben mitte', description: 'Oben mitte' },
        tr: { label: 'Oben rechts', description: 'Oben rechts' },
        ml: { label: 'Mitte links', description: 'Mitte links' },
        mc: { label: 'Mitte', description: 'Mitte' },
        mr: { label: 'Mitte rechts', description: 'Mitte rechts' },
        bl: { label: 'Unten links', description: 'Unten links' },
        bc: { label: 'Unten mitte', description: 'Unten mitte' },
        br: { label: 'Unten rechts', description: 'Unten rechts' },
      },
    },
  },
  // This renders the component when the parent is the slider.
  renderFor: {
    parentBundle: 'slider',
  },
})

const cropAlignment = computed(() =>
  resolveCantoCropAlignment(options.value.cropAlignment),
)

const description = computed(
  () =>
    props.captionOverride ||
    (props.image &&
      'image' in props.image &&
      (props.image?.image?.title || props.image?.image?.alt || props.image)) ||
    (props.image && 'assetId' in props.image && props.image.altCanto) ||
    '',
)
</script>
